export class AddToBasketPerformanceMarketing {

    sendData() {
        const performanceMarketingElement = document.querySelector<HTMLElement>('.or_js_addToBasketConfirmationSheet__performanceMarketing');
        if (performanceMarketingElement) {
            try {
                window.lhotse.exactag.data.pt = performanceMarketingElement.dataset.pt;
                window.lhotse.exactag.data.ab = [
                    {
                        vi: performanceMarketingElement.dataset.vi,
                        pi: performanceMarketingElement.dataset.pi,
                        ac: performanceMarketingElement.dataset.ac,
                        gp: performanceMarketingElement.dataset.gp
                    }
                ];
                this.trackAddToBasket();
            } catch (e) {
                console.error(e);
            }
        }
    }

    private trackAddToBasket() {
        window.lhotse.exactag.track();
        window.o_order.utils.activateFeatureCompleted('exactag-add-to-basket');
    }
}
